// CONFIG
export const CONFIG_URI = "/config";
export const OIDC_LOGOUT_URI = "/loggedout";

// OIDC
export const OIDC_CALLBACK_URI = "/callback";

export const OIDC_SILENT_RENEW_URI = "/oidc-silent-renew";
export const OIDC_SCOPE = "openid stanlab_read stanlab_write";
export const OIDC_RESPONSE_TYPE = "code";
export const OIDC_EXPIRING_NOTIF_TIME = 120;

export const TOAST_DURATION = 7000;

export const OrganizationTypes = {
  Mægler: "Mægler",
  Partner: "Partner",
  TiedAgent: "Tied Agents",
  Firmakunde: "Firmakunde",
};

export const ORGANIZATION_TYPES = [
  {
    label: "Mægler",
    value: OrganizationTypes.Mægler,
  },
  {
    label: "Partner",
    value: OrganizationTypes.Partner,
  },
  {
    label: "Tied Agents",
    value: OrganizationTypes.TiedAgent,
  },
  {
    label: "Firmakunde",
    value: OrganizationTypes.Firmakunde,
  },
];

export function getAllowedAdminOrganizationTypes(userPrincipal: any): any {
  const allowedOrganizationTypes = [];

  if (userPrincipal.isSuperAdmin) {
    return [...ORGANIZATION_TYPES];
  }

  if (userPrincipal.hasOrganizationFirmakundeAdminRole) {
    allowedOrganizationTypes.push({
      label: "Firmakunde",
      value: OrganizationTypes.Firmakunde,
    });
  }

  if (userPrincipal.hasOrganizationTiedAgentsAdminRole) {
    allowedOrganizationTypes.push({
      label: "Tied Agents",
      value: OrganizationTypes.TiedAgent,
    });
  }

  if (userPrincipal.hasOrganizationPartnerAdminRole) {
    allowedOrganizationTypes.push({
      label: "Partner",
      value: OrganizationTypes.Partner,
    });
  }

  if (userPrincipal.hasOrganizationMaeglerAdminRole) {
    allowedOrganizationTypes.push({
      label: "Mægler",
      value: OrganizationTypes.Mægler,
    });
  }

  return allowedOrganizationTypes;
}

export const getSeverity = (type: string) => {
  switch (type) {
    case OrganizationTypes.Mægler:
      return "info";
    case OrganizationTypes.Partner:
      return "success";
    case OrganizationTypes.TiedAgent:
      return "secondary";
    case OrganizationTypes.Firmakunde:
      return "warning";
  }
};

export const getOrganizationType = (type: string) => {
  const findValue = ORGANIZATION_TYPES.find((x) => x.value == type);
  if (findValue) {
    return findValue.label;
  }
  return "";
};
